import { useAuthStore } from '@/stores/authStore';
import * as AuthService from '@/services/api/endpoints/AuthService';
import type { LoginRequest } from '@/types';

export function useAuth() {
  const { setAuth, clearAuth, setLoading, user, isAuthenticated, isLoading } = useAuthStore();

  const login = async (credentials: LoginRequest) => {
    const response = await AuthService.login(credentials);
    if (response.user.role !== 'SUPER_ADMIN') {
      await AuthService.logout();
      throw new Error('ACCESS_DENIED');
    }
    setAuth(response.user, response.accessToken);
    return response;
  };

  const logout = async () => {
    await AuthService.logout();
    clearAuth();
  };

  const checkAuth = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const currentUser = await AuthService.getCurrentUser();
      if (currentUser.role !== 'SUPER_ADMIN') {
        await AuthService.logout();
        clearAuth();
      } else {
        setAuth(currentUser, token);
      }
    } catch {
      clearAuth();
    }
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    checkAuth,
  };
}
